export const getPhoneNumberFromOrderLine = (orderLine: any): string => {
  if (! orderLine.additionalData) {
    if (!orderLine.isMainProduct && orderLine.mainProduct) {
      return getPhoneNumberFromOrderLine(orderLine.mainProduct);
    }

    return '';
  }

  const phoneNumber = getPhoneNumberFromAdditionalData(orderLine.additionalData);

  if (phoneNumber) {
    return phoneNumber;
  }

  if (!orderLine.isMainProduct && orderLine.mainProduct) {
      return getPhoneNumberFromOrderLine(orderLine.mainProduct);
  }

  return phoneNumber;
};

export const getPhoneNumberFromAdditionalData = (additionalData: any): string => {
  if (! additionalData) {
    return '';
  }

  if (additionalData.isPorting) {
    return additionalData.numberToPort;
  }

  return additionalData.tmlOldNumber || additionalData.tmlCopyNumber || '';
};
